// extracted by mini-css-extract-plugin
module.exports = {"legend":"yObGkiMN","legendItem":"Xs8sUrvf","legendLabel":"PEkqwxDa","iconPrimary":"YR1tocTH","iconBar":"g20mOP28","iconMedian":"aMb3_MDv","iconCumulativeReturn":"kgY0eCzs"};